export default "__VITE_ASSET__zwSmjLG6__"